import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

import HeaderComponent from './components/Header';
import Home from './views/Home';
import Fixture from './views/Fixture';
import Layout, { Content, Footer, Header } from 'antd/es/layout/layout';
import FooterComponent from './components/Footer';
import { styles } from './styles';
import { HOME_PATH } from './utils/constant';
import Loader from './components/common/Loader';

const BlogDetailsPage = lazy(() => import('./components/BlogsList/BlogDetailsPage'));
const HomeLink = lazy(() => import('./views/HomeLink'));
const FIFA2026App = lazy(() => import('./components/WorldCup'));
const AddStreamComponent = lazy(() => import('./components/addStream'));
const UpdateStream = lazy(() => import('./components/updateStream'));
const Standings = lazy(() => import('./views/Standings'));
const FixtureList = lazy(() => import('./views/FixtureList'));
const AboutUs = lazy(() => import('./components/AboutUs'));
const ContactUsComponent = lazy(() => import('./components/ContactUs'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const NotFound = lazy(() => import('./views/NotFound'));

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#000000',
  marginTop: 'auto',
};

const routeFallback = (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
    <Loader />
  </div>
);

const Router = () => {
  return (
    <Layout>
      <Header style={styles.header}>
        <HeaderComponent />
      </Header>
      <Content style={{ background: '#222121', textAlign: 'center', minHeight: '100vh' }}>
        <Suspense fallback={routeFallback}>
          <Routes>
            <Route path="/blogs/:id" element={<BlogDetailsPage />} />
            <Route path="/blogs" element={<HomeLink />} />
            <Route path="/streams/:categoryName" element={<Home />} />
            <Route path={HOME_PATH} element={<Home />} />
            <Route path="/fixture/:teams" element={<Fixture />} />
            <Route path="/fifa-world-cup-2026" element={<FIFA2026App />} />
            <Route path="/fixture/:teams/add" element={<AddStreamComponent />} />
            <Route path="/fixture/:teams/update" element={<UpdateStream />} />
            <Route path="/leagues/standings" element={<Standings />} />
            <Route path="/leagues/:leagueName/:id" element={<FixtureList />} />
            <Route path="/teams/:teamName/:id" element={<FixtureList />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUsComponent />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/buffstream" element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Content>
      <Footer style={footerStyle}>
        <FooterComponent />
      </Footer>
    </Layout>
  );
};

export default Router;
